import { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'

import { CellWithTooltip, createDateTimeCellHook, useTimeInOrgTimezoneCell } from 'core/table/cells'
import { DYNAMIC_TEXT } from 'core/table/filters'
import { createDateValueSort } from 'components/table/sort'

export const useStyles = makeStyles(theme => ({
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    cursor: 'pointer',
  },
  selectColumn: {
    overflow: 'visible',
    '&>div': {
      overflow: 'visible',
      width: '36px',
      '&>$subRow': {
        position: 'relative',
        left: '40px',
      },
    },
  },
  nameColumn: {
    '&>div': {
      width: '250px',
    },
  },
  timeColumn: {
    '&>div': {
      width: '150px',
    },
  },
}))

const useDateCell = createDateTimeCellHook('MM/DD/YYYY')

export default function useEventSelectFieldColumns() {
  const DateCell = useDateCell()
  const TimeCell = useTimeInOrgTimezoneCell()

  const classes = useStyles()

  return useMemo(() => {
    return [
      {
        id: 'name',
        Header: 'Event Name',
        accessor: 'name',
        Cell: CellWithTooltip,
        filter: DYNAMIC_TEXT,
        className: classes.nameColumn,
      },
      {
        id: 'date',
        Header: 'Date',
        Cell: DateCell,
        accessor: 'startsAt',
        // @ts-ignore
        disableFilters: true,
        disableGlobalFilters: true,
        sortType: createDateValueSort('startsAt'),
        className: classes.dateColumn,
      },
      {
        id: 'startsAt',
        Header: 'Start',
        Cell: TimeCell,
        accessor: 'startsAt',
        disableFilters: true,
        disableGlobalFilters: true,
        sortType: createDateValueSort('startsAt'),
        className: classes.timeColumn,
      },
      {
        id: 'endsAt',
        Header: 'End',
        Cell: TimeCell,
        accessor: 'endsAt',
        disableFilters: true,
        disableGlobalFilters: true,
        sortType: createDateValueSort('endsAt'),
        className: classes.timeColumn,
      },
    ]
  }, [classes.nameColumn, classes.dateColumn, classes.timeColumn, DateCell, TimeCell])
}
